import { render, staticRenderFns } from "./Sug.vue?vue&type=template&id=d756143c&scoped=true&"
import script from "./Sug.vue?vue&type=script&lang=js&"
export * from "./Sug.vue?vue&type=script&lang=js&"
import style0 from "./Sug.vue?vue&type=style&index=0&id=d756143c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d756143c",
  null
  
)

export default component.exports